<div class="container-fluid">
	<div class="row">
		<label class="text-date mb-3 ps-0">20 de noviembre 2023</label>
		<div (click)="FuncionComponent()" [class.historical]="!active" [class.historicalOn]="active" >
			<label class="text-primary-color-1 mt-2"><i class="fa  fa-check"></i> Nota de ingreso</label>
			<div class="float-end">
				<label class="text-primary-color-2 mt-2">8:30 am</label>
			</div>
			<p class="text-secondary-color">Dra Elizabeth Mendoza</p>
			<p class="text-secondary-color mb-2">Gastoenterológia</p>
		</div>
		<div class="ps-0 pe-0 mt-3">
			<label class="mt-2">Mostrando 1 de 1</label>
			<div class="float-end">
				<button mat-stroked-button color="alternative">Ver más</button>
			</div>
		</div>
	</div>
</div>